import { Typography } from '@remarkable/ark-web';

import { Feedback } from 'src/components';
import { AppPage } from 'src/components/AppPage';

import { Trans, useLingui } from '@lingui/react/macro';
import { CheckoutForm } from '../components/CheckoutForm';

export const WinbackOfferCheckoutPage = () => {
  const { t } = useLingui();
  return (
    <AppPage.Container>
      <div className="m-auto my-32 max-w-lm px-16 text-center lm:mt-56 ll:mt-64 ll:mb-48">
        <Typography variant="responsive-heading-lg">
          <Trans>Activate Connect</Trans>
        </Typography>

        <Typography variant="responsive-body-md" className="my-0">
          <Trans>Verify your payment details to start your free trial.</Trans>
        </Typography>
      </div>

      <AppPage.Content className="max-w-l2xl">
        <CheckoutForm />
        <Feedback
          className="my-32 mt-320"
          title={t`Did you find what you were looking for?`}
          feedbackTargetId="store-winback-offer-checkout"
        />
      </AppPage.Content>
    </AppPage.Container>
  );
};
